import SingleConditionSimulatorContainer from './SingleConditionSimulatorContainer'

export default SingleConditionSimulatorContainer
